import { render } from "./projectStatistics.vue?vue&type=template&id=41c33031&scoped=true&ts=true"
import script from "./projectStatistics.vue?vue&type=script&lang=ts"
export * from "./projectStatistics.vue?vue&type=script&lang=ts"

import "./projectStatistics.vue?vue&type=style&index=0&id=41c33031&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c33031"]])

export default __exports__